const initialColumns = [
    { id: 'country_title', label: 'Country', minWidth: 100, maxWidth: 200, align: 'center', is_sortable: true, is_sorted: false, sort_type: "asc", sort_name: "country" },
    { id: 'ban_description', label: 'BAN Description', minWidth: 300, maxWidth: '', align: 'center', is_sortable: true, is_sorted: false, sort_type: "asc", sort_name: "ban_description" },
    {
        id: 'ban_number',
        label: 'BAN Number',
        minWidth: 200,
        maxWidth: 200,
        align: 'center',
        is_sortable: true,
        is_sorted: false,
        sort_type: "asc",
        sort_name: "ban_number",
        // format: (value) => value.toLocaleString('en-US'),
    },
    {
        id: 'net_contribution',
        label: 'Net Contribution',
        minWidth: 200,
        maxWidth: 200,
        align: 'right',
        is_sortable: true,
        is_sorted: false,
        sort_type: "asc",
        sort_name: "net_contribution",
        // format: (value) => value.toFixed(2),
    },
    {
        id: 'volume',
        label: 'Volume (in UC)',
        minWidth: 150,
        maxWidth: 100,
        align: 'right',
        is_sortable: true,
        is_sorted: false,
        sort_type: "asc",
        sort_name: "volume",
        // format: (value) => value.toFixed(2),
    },
    {
        id: 'exclusion',
        label: 'Exclusion',
        minWidth: 200,
        maxWidth: 100,
        align: 'right',
        is_sortable: false,
        is_sorted: false,
        sort_type: "asc",
        sort_name: "exclusion",
        // format: (value) => value.toFixed(2),
    },
    {
        id: 'type',
        label: 'Narrative',
        minWidth: 300,
        maxWidth: 300,
        align: 'center',
        is_sortable: false,
        is_sorted: false,
        sort_type: "asc",
        sort_name: "type",
        // format: (value) => value.toFixed(2),
    },
    {
        id: 'comment',
        label: 'Comment',
        minWidth: 100,
        maxWidth: 350,
        align: 'center',
        is_sortable: false,
        is_sorted: false,
        sort_type: "asc",
        sort_name: "comment",
        // format: (value) => value.toFixed(2),
    },

];
export { initialColumns };